const coursesApp = Vue.createApp({
    data() {
        return {
            courses: courses,
            coursePage: 1,
            coursePerPage: typeof (numberOfCoursesPerPage) != "undefined" ? numberOfCoursesPerPage : 4,
            coursePages: [],
            totalNumberofCoursePages: 0,
            deliveryChannels: [],
            selectedDelivery: [],
            topics: [],
            selectedTopic: ""
        }
    },
    methods: {
        setCoursePages(courses) {
            this.coursePages = [];
            this.totalNumberofCoursePages = Math.ceil(courses.length / this.coursePerPage);
            this.coursePages = pagination(this.coursePage, this.totalNumberofCoursePages);
        },

        paginate(items, page, perPage) {
            let from = (page * perPage) - perPage;
            let to = (page * perPage);
            return items.slice(from, to);
        },

        setDeliveryChannel() {
            var courseDelivery = [];
            this.courses.forEach(function (course) {
                courseDelivery = courseDelivery.concat(course.productType);
            });

            this.deliveryChannels = courseDelivery.filter((item, i, ar) => ar.indexOf(item) === i);
        },

        setTopics() {
            var courseTopic = [];
            this.courses.forEach(function (course) {
                courseTopic = courseTopic.concat(course.practiceArea);
            });

            this.topics = courseTopic.filter((item, i, ar) => ar.indexOf(item) === i);
        },

        resetPages() {
            this.coursePage = 1;
        },

        onTopicChange() {
            this.resetPages();
        },

        onDeliveryChange() {
            this.resetPages();
        }
    },
    computed: {
        displayedCourses() {
            var filteredCourses = this.courses.filter(function (item) {
                return ((this.selectedDelivery.some(i => item.productType.includes(i))  || this.selectedDelivery == "") && (item.practiceArea.includes(this.selectedTopic) || this.selectedTopic == ""));
            }, this);
            this.setCoursePages(filteredCourses);
            return this.paginate(filteredCourses, this.coursePage, this.coursePerPage);
        }
    },
    watch: {
        courses() {
            this.setCoursePages();
        },

        coursePage: function (val) {
            scrollOnPagination("pgn-courses");
        }
    },

    created() {
        this.setDeliveryChannel();
        this.setTopics();
        setTimeout(function () {
            $('#InPerson, #Virtual, #OnDemand').prop('checked', false);
        }, 500);
    },
    filters: {
        trimWords(value) {
            return value.split(" ").splice(0, 20).join(" ") + '...';
        }
    }
});

const coursesMountedApp = coursesApp.mount('#courses');

document.querySelectorAll('button[data-bs-toggle="tab"]').forEach((t, i) => {
    t.addEventListener('show.bs.tab', function (event) {
        var targetClass = event.target.dataset["bsTarget"];
        var panes = document.querySelectorAll(targetClass);
        var siblings = document.querySelectorAll('#product-tab-content .tab-pane.active');

        siblings.forEach(function (sibling) {
            sibling.classList.remove('show');
            sibling.classList.remove('active');
        });

        panes.forEach(function (pane) {
            pane.classList.add('show');
            pane.classList.add('active');
        });
    })
})